import { getDefaultStore } from '../../utility/environmentUtils'

export default {
  analyticsStoreNumber (state, getters, rootState, rootGetters) {
    if (rootGetters['session/isMobileMoney']) {
      return state.mobileMoneyLocation.toString()
    }

    return state.number.toString()
  },

  analyticsStoreBrand (state, getters, rootState, rootGetters) {
    if (rootGetters['session/isMobileMoney']) {
      return state.mobileMoneyType
    }

    return process.env.VUE_APP_AppBrand
  },

  defaultStoreNumber (state, getters, rootState) {
    if (state.qrCodeScannedStore) {
      return state.number
    }

    return rootState.session.config?.defaultStoreNumber || getDefaultStore()
  }
}
